"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _GridMixin = require("../../mixins/components/GridMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
/**
 * A component implementation of standard CSS Grid.
 * No CSS will be added and browser defaults will be used unless you set a prop.
 * All props are camel-cased CSS attributes. By default,
 * each `Grid` component uses a `div` -- if needed, you can use the styled-components
 * [`as`](https://www.styled-components.com/docs/api#as-polymorphic-prop) prop to change
 * the element type.
 *
 * IE11 follows an older version of the grid specification, and as such, not all functionality is
 * supported. See [IE11-compatible examples](#ie11-compatible-examples) below for additional
 * information and examples.
 *
 * **All `Grid` props support inline media query objects.**
 *
 * @related ['Flex', 'GridContent', 'GridLayout']
 * @since 8.22.0
 */
var Grid = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['display', 'order'])
}).withConfig({
  displayName: "Grid",
  componentId: "c11n-8-107-0__sc-18zzowe-0"
})(["", ""], _GridMixin.GridMixin);
exports.Grid = Grid;
Grid.propTypes = {
  /** *Property for the Parent (Grid Container)* */
  display: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['grid', 'inline-grid', 'none'])),
  /** *Property for the Parent (Grid Container)* */
  gridTemplateColumns: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  gridTemplateRows: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  gridTemplateAreas: _customPropTypes.default.inlineMediaQuery(_propTypes.default.arrayOf(_propTypes.default.string)),
  /** *Property for the Parent (Grid Container)* */
  gridTemplate: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /**
   * *Property for the Parent (Grid Container)*
   *
   * A spacing value
   */
  columnGap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /**
   * *Property for the Parent (Grid Container)*
   *
   * A spacing value
   */
  rowGap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /**
   * *Property for the Parent (Grid Container)*
   *
   * @deprecated Use `columnGap`
   */
  gridColumnGap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /**
   * (grid containers)
   *
   * @deprecated Use `rowGap`
   */
  gridRowGap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /**
   * *Property for the Parent (Grid Container)*
   *
   * A spacing value
   */
  gap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /**
   * *Property for the Parent (Grid Container)*
   *
   * @deprecated Use `gap`
   */
  gridGap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  justifyItems: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center', 'stretch'])),
  /** *Property for the Parent (Grid Container)* */
  alignItems: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center', 'stretch'])),
  /** *Property for the Parent (Grid Container)* */
  placeItems: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  justifyContent: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'])),
  /** *Property for the Parent (Grid Container)* */
  alignContent: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'])),
  /** *Property for the Parent (Grid Container)* */
  placeContent: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  gridAutoColumns: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  gridAutoRows: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  gridAutoFlow: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for the Parent (Grid Container)* */
  grid: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  gridColumnStart: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  gridColumnEnd: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  gridRowStart: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  gridRowEnd: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  gridColumn: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  gridRow: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  gridArea: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  justifySelf: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center', 'stretch'])),
  /** *Property for Children (Grid Items)* */
  alignSelf: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center', 'stretch'])),
  /** *Property for Children (Grid Items)* */
  placeSelf: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** *Property for Children (Grid Items)* */
  order: _customPropTypes.default.inlineMediaQuery(_propTypes.default.number)
};

/** @component */